import { Component, OnInit } from '@angular/core';
import { Router , NavigationEnd} from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import { AssessmentsService } from '../../shared/services/assessments.service';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {

  public currentUrl: any;
  public previousUrl: any;
  public shouldIDisplaySelfReview = 0;
  constructor(
    public router: Router,
    public AssessmentsServiceObj: AssessmentsService,
    public authService: AuthService
  ) {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.previousUrl = this.currentUrl;
          this.currentUrl = event.url;
        };
        if (this.previousUrl === '/home/associate/my-profile' && this.currentUrl === '/disclaimer') {
            this.previousUrl = undefined;
            this.router.navigate(['home/associate/feed']);
            return;
        }
      });
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.AssessmentsServiceObj.shouldIDisplayProfileReview().then(res => {
      if(res['shouldIDisplayProfileReview']){
        this.shouldIDisplaySelfReview = 2;
        AssessmentsService.shouldIDisplayProfileReviewBeh.next(true);
      } else {
        this.shouldIDisplaySelfReview = 1;
        AssessmentsService.shouldIDisplayProfileReviewBeh.next(false);
      }
    }).catch(err => {
      console.log('err');
    });
  }

  routeToFeed() {
    if (this.shouldIDisplaySelfReview === 2) {
      this.router.navigate(['/home/talent-management/self-assessment', this.authService.user.associateId]);
      AssessmentsService.shouldIDisplayProfileReviewBeh.next(true);
    } else {
      // this.router.navigate(['/home/associate/my-profile']);
      this.router.navigate(['/home/associate/feed']);
      AssessmentsService.shouldIDisplayProfileReviewBeh.next(false);
    }
  }

}
